import * as Types from '../actions/Types'

const INITIAL_STATE = {
  isCreating: [],
  isDeleting: [],
  isDeletingSubscription: [],
  isCreatingSubscription: []
}

export default (state = INITIAL_STATE, action) => {
  const { payload, type } = action
  switch (type) {
    case Types.MAKE_BOOKING:
      return {
        ...state,
        isCreating: [...state.isCreating, payload]
      }
    case Types.MAKE_BOOKING_SUCCESS:
      return {
        ...state,
        isCreating: state.isCreating.filter(
          booking =>
            booking.laundryId !== payload.laundryId &&
            booking.timeId !== payload.timeId &&
            booking.date !== payload.date
        )
      }
    case Types.MAKE_BOOKING_FAILED:
      return {
        ...state,
        isCreating: state.isCreating.filter(
          booking =>
            booking.laundryId !== payload.laundryId &&
            booking.timeId !== payload.timeId &&
            booking.date !== payload.date
        )
      }
    case Types.DELETE_BOOKING:
      return {
        ...state,
        isDeleting: [...state.isDeleting, payload]
      }
    case Types.DELETE_BOOKING_SUCCESS:
      return {
        ...state,
        isDeleting: state.isDeleting.filter(id => id !== payload)
      }
    case Types.DELETE_BOOKING_FAILED:
      return {
        ...state,
        isDeleting: state.isDeleting.filter(id => id !== payload)
      }
    case Types.SUBSCIRBE_TO_BOOKING:
      return {
        ...state,
        isCreatingSubscription: [...state.isCreatingSubscription, payload]
      }
    case Types.SUBSCIRBE_TO_BOOKING_SUCCESS:
      return {
        ...state,
        isCreatingSubscription: state.isCreatingSubscription.filter(
          id => id.toString() !== payload.bookingId.toString()
        )
      }
    case Types.SUBSCIRBE_TO_BOOKING_FAILED:
      return {
        ...state,
        isCreatingSubscription: state.isCreatingSubscription.filter(
          id => id.toString() !== payload.toString()
        )
      }
    case Types.UNSUBSCIRBE_TO_BOOKING:
      return {
        ...state,
        isDeletingSubscription: [...state.isDeletingSubscription, payload]
      }
    case Types.UNSUBSCIRBE_TO_BOOKING_SUCCESS:
      return {
        ...state,
        isDeletingSubscription: state.isDeletingSubscription.filter(
          id => id.toString() !== payload.toString()
        )
      }
    case Types.UNSUBSCIRBE_TO_BOOKING_FAILED:
      return {
        ...state,
        isDeletingSubscription: state.isDeletingSubscription.filter(
          id => id.toString() !== payload.toString()
        )
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/LaundryBookings.js